var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMain1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9519 1.04712C17.5543 -0.350402 15.2885 -0.350332 13.8911 1.04727L1.94103 12.9987C1.5347 13.4051 1.2491 13.9162 1.116 14.4753L0.0204088 19.0767C-0.0399112 19.3301 0.0355188 19.5966 0.219679 19.7808C0.403849 19.9649 0.670369 20.0404 0.923729 19.98L5.52498 18.8845C6.08418 18.7514 6.59546 18.4656 7.00191 18.0591L16.9995 8.0604C17.6777 8.7442 17.676 9.8484 16.9943 10.5301L15.2109 12.3135C14.918 12.6064 14.918 13.0812 15.2109 13.3741C15.5038 13.667 15.9786 13.667 16.2715 13.3741L18.055 11.5907C19.3224 10.3233 19.3242 8.2693 18.0601 6.99967L18.952 6.10763C20.3493 4.71015 20.3493 2.44453 18.9519 1.04712ZM14.9518 2.10787C15.7634 1.29611 17.0795 1.29607 17.8912 2.10778C18.7028 2.91942 18.7029 4.23534 17.8913 5.04704L5.94119 16.9985C5.73104 17.2087 5.46668 17.3564 5.17755 17.4253L1.76191 18.2385L2.57521 14.8227C2.64402 14.5337 2.79168 14.2694 3.00175 14.0593L14.9518 2.10787Z",
    fill: "#13559F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain1);
export default __webpack_public_path__ + "static/media/main-1.2b7d5d00501020ce317e428f2abcaa45.svg";
export { ForwardRef as ReactComponent };